import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
// service
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
    selector: 'app-bound-book-btns',
    templateUrl: './bound-book-btns.component.html',
    styleUrls: ['./bound-book-btns.component.scss'],
    standalone: true,
    imports: []
})
export class BoundBookBtnsComponent implements ICellRendererAngularComp {
  params: any;
  editButtonsVisible = true;
  deleteButtonsNotVisible = false;
  constructor(
    private sharedService: SharedService
  ) {

  }
  agInit(params: any): void {
    this.params = params;
  }
  refresh(params?: any): boolean {
    return true;
  }

  // Button functions
  viewFirearmDetailsClick() {
    const rowData = {
      colValues: this.params.node.data,
      rowIndex: this.params.rowIndex,
    };
    this.params.viewFirearmDetails(rowData);
  }
  printPackingSlipClick() {
    const rowData = {
      colValues: this.params.node.data,
      rowIndex: this.params.rowIndex,
    };
    
    this.params.printPackingSlip(rowData);
  }
  send3310EmailClick() {
    const rowData = {
      colValues: this.params.node.data,
      rowIndex: this.params.rowIndex,
    };
    this.params.send3310Email(rowData);
  }
  // deleteFirearmClick() {
  //   const rowData = {
  //     colValues: this.params.node.data,
  //     rowIndex: this.params.rowIndex,
  //   };
  //   this.params.deleteFirearm(rowData);
  // }
}
